'use client';

import { useRef } from 'react';
import { useIntl } from 'react-intl';

import { useTrackEventAmplitude } from '../../../../core/Tracking/Amplitude/Amplitude';
import { Typography } from '../../../../design-system/components/typography/Typography';
import { QuestionAnswer } from '../../../../resources/questionAnswer/domain/types/questionAnswer';
import { QuestionsAnswersAccordion } from '../../../../shared/components/QuestionsAnswersAccordion/QuestionsAnswersAccordion';
import { useTrackBlockViewed } from '../../../../shared/hooks/useTrackBlockViewed';
import { useCurrentSite } from '../../../../shared/providers/currentSite/useCurrentSite';

import style from './QuestionsAnswersSection.module.css';

export function QuestionsAnswersSection({
    questionsAnswers,
}: {
    questionsAnswers: Array<QuestionAnswer>;
}) {
    const { formatMessage } = useIntl();
    const { currentSite } = useCurrentSite();
    const { trackEvent } = useTrackEventAmplitude();
    const sectionRef = useRef<HTMLDivElement>(null);

    const helpCenterUrl = currentSite.pages.faq.url;

    useTrackBlockViewed(sectionRef, 'faq');

    return (
        <section ref={sectionRef} className="layout-with-centered-content">
            <div className="main-container">
                <div className={style.container}>
                    <h2 className={style.title}>
                        {formatMessage({ id: 'page.home.faqSection.title' })}
                    </h2>

                    <div className={style.accordionContainer}>
                        <QuestionsAnswersAccordion questionsAnswers={questionsAnswers} />

                        {helpCenterUrl ? (
                            <Typography
                                as="div"
                                scale="primary-s-regular"
                                className={style.helpCenterWrapper}
                            >
                                {formatMessage({ id: 'page.home.faqSection.helpcenterLink' })}{' '}
                                <a
                                    className="link"
                                    href={helpCenterUrl}
                                    onClick={() => {
                                        trackEvent((ampli, defaultProperties) => {
                                            ampli.helpCenterClicked({
                                                ...defaultProperties,
                                                block: 'faq',
                                            });
                                        });
                                    }}
                                >
                                    {formatMessage({ id: 'global.footer.links.helpCenter' })}
                                </a>
                            </Typography>
                        ) : null}
                    </div>
                </div>
            </div>
        </section>
    );
}
